import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
// import editIcon from '../../assets/images/icons/icon-edit.svg';
// import delIcon from '../../assets/images/icons/icon-delete.svg';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
// import DeleteAgencyModal from '../Modals/AgencyModals/DeleteAgencyModal';
// import DetailAgencyModal from '../Modals/AgencyModals/DetailAgencyModal';
// import EditAgencyModal from '../Modals/AgencyModals/EditAgencyModal';
import DataTable from 'react-data-table-component';
// import warningIcon from '../../assets/images/status-icon.svg';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
import moment from 'moment';

import DatePicker from 'react-multi-date-picker';
import Footer from 'react-multi-date-picker/plugins/range_picker_footer';
import CustomInput from './DateFilterCustom';
import useQueryParamsPage from '../../hooks/useQueryParamsPage';
const Agencies = () => {
    const [trips, setTrips] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const { searchParams, page, updateQueryParams, setPage } = useQueryParamsPage();
    const [searchValue, setSearchValue] = useState(searchParams.get('search') || '');

    const { getToken } = useAuth();
    const navigate = useNavigate();
    const [value, setValue] = useState([]);

    useEffect(() => {
        getAllTrips();
    }, [value?.[0], value?.[1], page]);

    const handleClose = () => {
        setShowDelModal(false);
        // setChangeStatusModal(false);
        setShowBulkDel(false);
    };

    const getAllTrips = async (pageSize = 10, pageNo = 0, _search) => {
        const authToken = getToken();

        if (authToken) {
            new WebApiCalls()
                .getAllTrips(
                    authToken,
                    pageSize,
                    page,
                    searchValue,
                    value?.[0] ? new Date(value[0])?.toDateString() : undefined,
                    value?.[1] ? new Date(value[1])?.toDateString() : undefined
                )
                .then((res) => {
                    if (res?.code && res.code === 200) {
                        setTrips(res.data?.trips);
                        // setAgencies(res?.data?.agencies);
                        // calcPagination(res.data?.totalRecord);
                        setTotalRecords(res.data?.totalCount);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .tripDelete(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Trip has been deleted successfully.');
                        getAllTrips();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Trip ID</span>
                </h6>
            ),
            selector: (row) => row?.trip_id,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Trip Headsign</span>
                </h6>
            ),
            selector: (row) => row?.trip_headsign,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Service ID</span>
                </h6>
            ),
            selector: (row) => row?.service_id,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Route</span>
                </h6>
            ),
            selector: (row) => {
                const shortName = row?.route?.route_short_name || '';
                const longName = row?.route?.route_long_name || '';
                return shortName + (longName ? ` - ${longName}` : '');
            },
            sortable: true,
            sortFunction: (a, b) => {
                const aValue = (a?.route?.route_short_name || '') + (a?.route?.route_long_name || '');
                const bValue = (b?.route?.route_short_name || '') + (b?.route?.route_long_name || '');
                return aValue.localeCompare(bValue);
            },
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Transit Type</span>
                </h6>
            ),
            selector: (row) => {
                const type = row?.route?.transit_type || '';
                return type.charAt(0).toUpperCase() + type.slice(1);
            },
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <img
                            width={15}
                            className="me-3"
                            src={viewIcon}
                            alt=""
                            onClick={() => {
                                navigate('/trips/trip-details', {
                                    state: {
                                        trip_id: row._id
                                    }
                                });
                            }}
                        />
                    </div>
                    {/* <div className="del-detail">
                        <img
                            width={15}
                            src={delIcon}
                            alt=""
                            onClick={() => {
                                setSelectedItem(row);
                                setShowDelModal(true);
                            }}
                        />
                    </div> */}
                </div>
            ),
            center: true
            // sortable: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
        updateQueryParams({ page: pageNo, search: searchValue });
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllTrips(pageSize, pageNo);
        setPageSize(pageSize);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllTrips(undefined, undefined, text);
    }, 2000);

    const deleteBulk = async () => {
        try {
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkTrips(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllTrips();
                            toast.success(selectedRows.length > 1 ? 'Trips have been deleted successfully.' : 'Trip has been deleted successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        console.log('ERROR while Deleting Bulk Trips', err);
                    });
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const handleClearDate = () => {
        setValue([]);
        if (searchValue) {
            setSearchValue('');
            searchDebounce('');
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            {/* Modal For deleting multiple agencies */}
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Trip?'} />

            {/* Modal For deleting multiple agencies */}
            <CommonModal handleClose={handleClose} show={showBulkDel} handleDelete={deleteBulk} text={'Are you sure, you want to delete Trips?'} />

            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                            setSearchValue(e.target.value);
                        }}
                        value={searchValue}
                    />
                </Col>
                <Col md={3}>
                    <div className="d-flex gap-2">
                        <DatePicker
                            render={<CustomInput />}
                            value={value}
                            onChange={setValue}
                            range
                            numberOfMonths={2}
                            rangeHover
                            plugins={[<Footer position="bottom" />]}
                        />
                        <Button onClick={handleClearDate}>Clear Filter</Button>
                    </div>
                </Col>
                <Col sm={6} md={6}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        setShowBulkDel(true);
                                        // deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={trips}
                progressPending={trips && trips?.length >= 0 ? false : true}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationDefaultPage={parseInt(searchParams.get('page')) || 1}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default Agencies;
